// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Shared "MCR Brands" table skin for pages built on the Brand.module.css
   card (cardOuter > headerBar + bodyArea) plus the <Paginated> component
   (.custom-table / .page_link_item).

   Opt in by adding the plain class \`mcrb-card\` to the card element
   (the \`cardOuter\` div). Optionally add \`mcrb-page\` to the page wrapper
   for the framed grey background. Everything is scoped to those classes,
   so no other page is affected.
   ========================================================================== */

.mcrb-page {
  padding: 24px !important;
  background: #f4f5f7;
}

/* ---------- Card ------------------------------------------------- */
.mcrb-card {
  max-width: 1180px;
  margin: 0 auto !important;
  border: 1px solid #e6e8ec !important;
  border-radius: 18px !important;
  box-shadow: 0 10px 40px -18px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

/* ---------- Header bar → theme gradient ------------------------- */
.mcrb-card > div:first-child {
  padding: 22px 28px;
  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%);
  border-bottom: none;
}

.mcrb-card > div:first-child span,
.mcrb-card > div:first-child p,
.mcrb-card > div:first-child h1,
.mcrb-card > div:first-child h2,
.mcrb-card > div:first-child h3,
.mcrb-card > div:first-child h4,
.mcrb-card > div:first-child h5,
.mcrb-card > div:first-child h6,
.mcrb-card > div:first-child [class*="title"],
.mcrb-card > div:first-child [class*="Title"] {
  color: #f8fafc !important;
  letter-spacing: 0.02em;
}

/* header action buttons / link-buttons → translucent pills on the gradient */
.mcrb-card > div:first-child button,
.mcrb-card > div:first-child a[class],
.mcrb-headbar button,
.mcrb-headbar a[class] {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px !important;
  border-radius: 12px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.16) !important;
  color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.32) !important;
  box-shadow: none !important;
  transition: background 0.15s ease;
}

.mcrb-card > div:first-child button:hover:not(:disabled),
.mcrb-card > div:first-child a[class]:hover,
.mcrb-headbar button:hover:not(:disabled),
.mcrb-headbar a[class]:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  transform: none !important;
  box-shadow: none !important;
}

/* Outer card frame only — no header/table rules. Pair with \`mcrb-headbar\`
   for pages that can't use the first-child header selector. */
.mcrb-frame {
  max-width: 1180px;
  margin: 0 auto !important;
  border: 1px solid #e6e8ec !important;
  border-radius: 18px !important;
  box-shadow: 0 10px 40px -18px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

/* Direct hook for pages whose header bar is NOT the card's first child
   (e.g. wrapped in a conditional div). Add \`mcrb-headbar\` on the headerBar. */
.mcrb-headbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 22px 28px !important;
  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%) !important;
  border-bottom: none !important;
}

.mcrb-headbar > span,
.mcrb-headbar p,
.mcrb-headbar h1,
.mcrb-headbar h2,
.mcrb-headbar h3,
.mcrb-headbar h4,
.mcrb-headbar h5,
.mcrb-headbar h6,
.mcrb-headbar [class*="title"],
.mcrb-headbar [class*="Title"] {
  color: #f8fafc !important;
  letter-spacing: 0.02em;
}

/* ---------- Toolbar row (filters below the header) ----------- */
.mcrb-toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  padding: 14px 24px;
  background: #fbfbfc;
  border-bottom: 1px solid #eceef1;
}

.mcrb-toolbar label,
.mcrb-toolbar > span {
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6B7280;
}

.mcrb-toolbar select,
.mcrb-toolbar input {
  height: 38px;
  border: 1px solid #dfe3e8;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 13px;
  color: #1f2937;
  background: #ffffff;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.mcrb-toolbar select:focus,
.mcrb-toolbar input:focus {
  border-color: #7c5cfc;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.16);
}

/* ---------- Table --------------------------------------------- */
.mcrb-card .custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: 'Inter', system-ui, -apple-system, sans-serif !important;
}

.mcrb-card .custom-table thead {
  background: transparent;
}

.mcrb-card .custom-table thead th,
.mcrb-card .custom-table th.table-border {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ede9fb;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  padding: 15px 20px;
  border: none;
  border-bottom: 1px solid #5b3fc8;
  white-space: nowrap;
}

.mcrb-card .custom-table tbody td {
  padding: 14px 20px;
  font-size: 13px;
  color: #1f2937;
  border-bottom: 1px solid #eef0f3;
  vertical-align: middle;
}

/* remove the old zebra striping + cyan hover */
.mcrb-card .custom-table tbody tr:nth-child(even) {
  background: #ffffff;
}

.mcrb-card .custom-table tbody tr {
  transition: background 0.14s ease;
}

.mcrb-card .custom-table tbody tr:hover {
  background: #f8fafc;
}

.mcrb-card .custom-table tbody tr:last-child td {
  border-bottom: none;
}

/* ---------- Pagination controls ----------------------------- */
.mcrb-card .page_link_item {
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  padding: 6px 12px;
  margin: 3px;
  font-size: 12.5px;
  font-weight: 600;
  color: #475569;
  background: #ffffff;
  transition: background 0.14s ease, border-color 0.14s ease, color 0.14s ease;
}

.mcrb-card .page_link_item:hover:not(:disabled) {
  color: #4c2fb3;
  border-color: #c9bef0;
  background: #f5f3ff;
}

.mcrb-card .page_link_item input,
.mcrb-card .page_link_item select {
  border: 1px solid #dfe3e8;
  border-radius: 6px;
  padding: 3px 4px;
}

/* ---------- Ant Design form body variant ---------------------
   Add \`mcrb-antdform\` to the body wrapper around an antd <Form>/<Collapse>. */
.mcrb-antdform {
  padding: 20px 24px 28px;
}

.mcrb-antdform .ant-collapse {
  border-radius: 12px;
  border-color: #e6e8ec;
  overflow: hidden;
  background: #ffffff;
}

.mcrb-antdform .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  font-weight: 700;
  color: #1f2430;
}

.mcrb-antdform .ant-input:hover,
.mcrb-antdform .ant-select:hover .ant-select-selector,
.mcrb-antdform .ant-picker:hover {
  border-color: #c9bef0 !important;
}

.mcrb-antdform .ant-input:focus,
.mcrb-antdform .ant-input-focused,
.mcrb-antdform .ant-select-focused .ant-select-selector,
.mcrb-antdform .ant-picker-focused {
  border-color: #7c5cfc !important;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.16) !important;
}

.mcrb-antdform .btn.btn-primary {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;
  border: none !important;
  font-weight: 700;
  letter-spacing: 0.02em;
  box-shadow: 0 12px 24px -6px rgba(76, 47, 179, 0.45);
}

/* ---------- Ant Design <Table> variant ------------------------
   Add \`mcrb-antd\` to the wrapper around an antd <Table>. */
.mcrb-antd .ant-table-thead > tr > th {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;
  color: #ede9fb !important;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 11px;
  font-weight: 600;
  border-bottom: 1px solid #5b3fc8 !important;
}

.mcrb-antd .ant-table-thead > tr > th::before {
  display: none !important;
}

.mcrb-antd .ant-table-tbody > tr > td {
  border-bottom: 1px solid #eef0f3;
  color: #1f2937;
}

.mcrb-antd .ant-table-tbody > tr:hover > td {
  background: #f8fafc !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/mcrbTableTheme.css"],"names":[],"mappings":"AAAA;;;;;;;;;+EAS+E;;AAE/E;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,mBAAmB;AACrB;;AAEA;;;;;;;;;;EAUE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gDAAgD;EAChD,yBAAyB;EACzB,sDAAsD;EACtD,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;;;EAIE,gDAAgD;EAChD,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;8DAC8D;AAC9D;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,+DAA+D;EAC/D,gBAAgB;AAClB;;AAEA;8EAC8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,qFAAqF;EACrF,8BAA8B;AAChC;;AAEA;;;;;;;;;;EAUE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,qEAAqE;AACvE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;8EAC8E;AAC9E;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;;EAIE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;2DAC2D;AAC3D;EACE,wEAAwE;EACxE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* ==========================================================================\n   Shared \"MCR Brands\" table skin for pages built on the Brand.module.css\n   card (cardOuter > headerBar + bodyArea) plus the <Paginated> component\n   (.custom-table / .page_link_item).\n\n   Opt in by adding the plain class `mcrb-card` to the card element\n   (the `cardOuter` div). Optionally add `mcrb-page` to the page wrapper\n   for the framed grey background. Everything is scoped to those classes,\n   so no other page is affected.\n   ========================================================================== */\n\n.mcrb-page {\n  padding: 24px !important;\n  background: #f4f5f7;\n}\n\n/* ---------- Card ------------------------------------------------- */\n.mcrb-card {\n  max-width: 1180px;\n  margin: 0 auto !important;\n  border: 1px solid #e6e8ec !important;\n  border-radius: 18px !important;\n  box-shadow: 0 10px 40px -18px rgba(15, 23, 42, 0.18) !important;\n  overflow: hidden;\n}\n\n/* ---------- Header bar → theme gradient ------------------------- */\n.mcrb-card > div:first-child {\n  padding: 22px 28px;\n  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%);\n  border-bottom: none;\n}\n\n.mcrb-card > div:first-child span,\n.mcrb-card > div:first-child p,\n.mcrb-card > div:first-child h1,\n.mcrb-card > div:first-child h2,\n.mcrb-card > div:first-child h3,\n.mcrb-card > div:first-child h4,\n.mcrb-card > div:first-child h5,\n.mcrb-card > div:first-child h6,\n.mcrb-card > div:first-child [class*=\"title\"],\n.mcrb-card > div:first-child [class*=\"Title\"] {\n  color: #f8fafc !important;\n  letter-spacing: 0.02em;\n}\n\n/* header action buttons / link-buttons → translucent pills on the gradient */\n.mcrb-card > div:first-child button,\n.mcrb-card > div:first-child a[class],\n.mcrb-headbar button,\n.mcrb-headbar a[class] {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 18px !important;\n  border-radius: 12px !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.02em;\n  line-height: 1.2;\n  white-space: nowrap;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.16) !important;\n  color: #ffffff !important;\n  border: 1px solid rgba(255, 255, 255, 0.32) !important;\n  box-shadow: none !important;\n  transition: background 0.15s ease;\n}\n\n.mcrb-card > div:first-child button:hover:not(:disabled),\n.mcrb-card > div:first-child a[class]:hover,\n.mcrb-headbar button:hover:not(:disabled),\n.mcrb-headbar a[class]:hover {\n  background: rgba(255, 255, 255, 0.28) !important;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* Outer card frame only — no header/table rules. Pair with `mcrb-headbar`\n   for pages that can't use the first-child header selector. */\n.mcrb-frame {\n  max-width: 1180px;\n  margin: 0 auto !important;\n  border: 1px solid #e6e8ec !important;\n  border-radius: 18px !important;\n  box-shadow: 0 10px 40px -18px rgba(15, 23, 42, 0.18) !important;\n  overflow: hidden;\n}\n\n/* Direct hook for pages whose header bar is NOT the card's first child\n   (e.g. wrapped in a conditional div). Add `mcrb-headbar` on the headerBar. */\n.mcrb-headbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 22px 28px !important;\n  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%) !important;\n  border-bottom: none !important;\n}\n\n.mcrb-headbar > span,\n.mcrb-headbar p,\n.mcrb-headbar h1,\n.mcrb-headbar h2,\n.mcrb-headbar h3,\n.mcrb-headbar h4,\n.mcrb-headbar h5,\n.mcrb-headbar h6,\n.mcrb-headbar [class*=\"title\"],\n.mcrb-headbar [class*=\"Title\"] {\n  color: #f8fafc !important;\n  letter-spacing: 0.02em;\n}\n\n/* ---------- Toolbar row (filters below the header) ----------- */\n.mcrb-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  padding: 14px 24px;\n  background: #fbfbfc;\n  border-bottom: 1px solid #eceef1;\n}\n\n.mcrb-toolbar label,\n.mcrb-toolbar > span {\n  font-size: 11.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #6B7280;\n}\n\n.mcrb-toolbar select,\n.mcrb-toolbar input {\n  height: 38px;\n  border: 1px solid #dfe3e8;\n  border-radius: 10px;\n  padding: 0 12px;\n  font-size: 13px;\n  color: #1f2937;\n  background: #ffffff;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.mcrb-toolbar select:focus,\n.mcrb-toolbar input:focus {\n  border-color: #7c5cfc;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.16);\n}\n\n/* ---------- Table --------------------------------------------- */\n.mcrb-card .custom-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif !important;\n}\n\n.mcrb-card .custom-table thead {\n  background: transparent;\n}\n\n.mcrb-card .custom-table thead th,\n.mcrb-card .custom-table th.table-border {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ede9fb;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  padding: 15px 20px;\n  border: none;\n  border-bottom: 1px solid #5b3fc8;\n  white-space: nowrap;\n}\n\n.mcrb-card .custom-table tbody td {\n  padding: 14px 20px;\n  font-size: 13px;\n  color: #1f2937;\n  border-bottom: 1px solid #eef0f3;\n  vertical-align: middle;\n}\n\n/* remove the old zebra striping + cyan hover */\n.mcrb-card .custom-table tbody tr:nth-child(even) {\n  background: #ffffff;\n}\n\n.mcrb-card .custom-table tbody tr {\n  transition: background 0.14s ease;\n}\n\n.mcrb-card .custom-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.mcrb-card .custom-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* ---------- Pagination controls ----------------------------- */\n.mcrb-card .page_link_item {\n  border: 1px solid #dfe3e8;\n  border-radius: 8px;\n  padding: 6px 12px;\n  margin: 3px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #475569;\n  background: #ffffff;\n  transition: background 0.14s ease, border-color 0.14s ease, color 0.14s ease;\n}\n\n.mcrb-card .page_link_item:hover:not(:disabled) {\n  color: #4c2fb3;\n  border-color: #c9bef0;\n  background: #f5f3ff;\n}\n\n.mcrb-card .page_link_item input,\n.mcrb-card .page_link_item select {\n  border: 1px solid #dfe3e8;\n  border-radius: 6px;\n  padding: 3px 4px;\n}\n\n/* ---------- Ant Design form body variant ---------------------\n   Add `mcrb-antdform` to the body wrapper around an antd <Form>/<Collapse>. */\n.mcrb-antdform {\n  padding: 20px 24px 28px;\n}\n\n.mcrb-antdform .ant-collapse {\n  border-radius: 12px;\n  border-color: #e6e8ec;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.mcrb-antdform .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  font-weight: 700;\n  color: #1f2430;\n}\n\n.mcrb-antdform .ant-input:hover,\n.mcrb-antdform .ant-select:hover .ant-select-selector,\n.mcrb-antdform .ant-picker:hover {\n  border-color: #c9bef0 !important;\n}\n\n.mcrb-antdform .ant-input:focus,\n.mcrb-antdform .ant-input-focused,\n.mcrb-antdform .ant-select-focused .ant-select-selector,\n.mcrb-antdform .ant-picker-focused {\n  border-color: #7c5cfc !important;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.16) !important;\n}\n\n.mcrb-antdform .btn.btn-primary {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;\n  border: none !important;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  box-shadow: 0 12px 24px -6px rgba(76, 47, 179, 0.45);\n}\n\n/* ---------- Ant Design <Table> variant ------------------------\n   Add `mcrb-antd` to the wrapper around an antd <Table>. */\n.mcrb-antd .ant-table-thead > tr > th {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%) !important;\n  color: #ede9fb !important;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 11px;\n  font-weight: 600;\n  border-bottom: 1px solid #5b3fc8 !important;\n}\n\n.mcrb-antd .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n\n.mcrb-antd .ant-table-tbody > tr > td {\n  border-bottom: 1px solid #eef0f3;\n  color: #1f2937;\n}\n\n.mcrb-antd .ant-table-tbody > tr:hover > td {\n  background: #f8fafc !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
